import React, { FunctionComponent } from 'react'
import Loader from './loader'

export interface Props {
  isLoading: boolean
}

const SectionLoader: FunctionComponent<Props> = ({ isLoading = false }) => {
  if (!isLoading) {
    return null
  }
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
      <Loader
        isLoading
        className={null}
        black
        style={{ display: 'block', margin: '50px auto', height: '50px' }}
      />
    </div>
  )
}

export default SectionLoader
